

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface NursingCounterParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface NursingCounter {
  nursingCounter?: any;
  bedNo?: any;
  room?: any;
  wardList?: any;
    id?: number;
     name:string; 
     floorId:any;
   isActive:string;
     buildingId:any;
    tenantId: any;
    branchId: any;
    bedStatus?:string;

    building?:any;
    floor?:any;
  parameters?: NursingCounterParameter[];
  links?: any;
}

export abstract class NursingCounterData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(url: string): Observable<NursingCounter[]>;
  abstract create(url: string, data: NursingCounter): Observable<NursingCounter[]>;
  abstract update(url: string, data: NursingCounter): Observable<NursingCounter>;
  abstract delete(url: string): Observable<any>;
 
}
